define('jqueryui',[
	'jquery', 
	'plugins/ui/jquery-ui',
	'css!plugins/ui/css/jquery-ui-wdn'
], function($) {
	return {
		initialize: function(callback) {
			$(callback);
		}
	};
});

